import React from "react";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from "@xyflow/react";

const WorkflowEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  label,
  selected,
  type,
}) => {
  const isConditional = type === "condicional";
  const isMostlyVertical = Math.abs(targetY - sourceY) > Math.abs(targetX - sourceX);
  const labelOffset = isMostlyVertical
    ? "translate(18px, -50%)"
    : "translate(-50%, -18px)";
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: selected ? "#91D500" : isConditional ? "#F5A623" : "#667085",
          strokeWidth: selected ? 2.5 : 1.5,
          strokeDasharray: isConditional ? "7 5" : undefined,
        }}
      />
      {label && (
        <EdgeLabelRenderer>
          <div
            className="workflow-edge-label nodrag nopan"
            style={{
              left: labelX,
              top: labelY,
              transform: labelOffset,
              zIndex: 20,
            }}
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default WorkflowEdge;
